<template>
  <!-- 店铺信息-基本信息 -->
  <div class="BasicInformation">
    <!-- 公司名 logo -->
    <div class="shop-basic-msg">
      <img src="" alt="" />
      <div class="shop-mark-guarantee">
        <div class="shop-Name">
          xxx科技发展有限公司
          <div class="AgeLimit">7年老店</div>
        </div>
        <div class="shop-mark">
          ID:66225511333888
          <div class="mark-box">
            <p v-for="(item, index) in 5" :key="index"></p>
          </div>
        </div>
        <!-- 保障 -->
        <div class="shop-guarantee">
          <p class="SecurityDeposit">1000元</p>
          <div class="TraceGold">
            <p class="ZJin">侦迹金</p>
            <!-- Images removed - unused files deleted -->
          </div>
        </div>
      </div>
      <!-- 公司简介 -->
      <div class="intro">
        <div class="intro-cen">
          <p class="title">公司简介：</p>
          <p class="introContent">
            喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {},
  components: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.BasicInformation {
  width: 100%;
  height: 100%;
  //   基本信息
  .shop-basic-msg {
    height: 60px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    display: flex;
    padding: 20px;
    img {
      width: 60px;
      height: 60px;
    }
    // 公司名 id 评分 保障
    .shop-mark-guarantee {
      min-width: 330px;
      height: 70px;
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      //
      .shop-Name {
        width: 100%;
        height: 20px;
        line-height: 20px;
        display: flex;
        font-size: 16px;
        color: #333333;
        .AgeLimit {
          width: 70px;
          height: 18px;
          line-height: 18px;
          background: #fe574a;
          border: 1px solid #fe574a;
          border-radius: 5px;
          margin-left: 30px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
        }
      }
      .shop-mark {
        width: 100%;
        height: 14px;
        line-height: 14px;
        margin: auto;
        display: flex;
        font-size: 12px;
        color: #333333;
        .mark-box {
          min-width: 100px;
          height: 14px;
          display: flex;
          margin-left: 30px;
          p {
            width: 15px;
            height: 14px;
            background-image: url("../../../../../../assets/imgs/shoucang@3x.svg");
            background-size: 100% 100%;
            margin-right: 5px;
          }
        }
      }
      .shop-guarantee {
        width: 100%;
        height: 20px;
        display: flex;
        .SecurityDeposit {
          min-width: 70px;
          height: 18px;
          line-height: 18px;
          background: rgba(97, 144, 232, 0.2);
          border: 1px solid #409eff ;
          border-radius: 5px;
          font-size: 12px;
          color: #409eff ;
          text-align: center;
        }
        .TraceGold {
          min-width: 205px;
          height: 20px;
          margin-left: 30px;
          display: flex;
          .ZJin {
            width: 50px;
            height: 20px;
            line-height: 20px;
            background: #3bb500;
            border-radius: 5px;
            font-size: 12px;
            color: #ffffff;
            text-align: center;
            margin-right: 10px;
          }
          img {
            height: 100%;
            width: 15px;
            margin-right: 5px;
          }
        }
      }
    }
    // 公司简介
    .intro {
      flex: 1;
      height: 70px;
      display: flex;
      .intro-cen {
        width: 400px;
        height: 70px;
        margin: auto;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        color: #333333;
        .title {
          width: 100%;
          height: 14px;
          margin-bottom: 10px;
        }
        .introContent {
          width: 100%;
          flex: 1;
        }
      }
    }
  }
}
</style>
